// InnerEaze smooth scrolling: eased mouse-wheel / trackpad scrolling on desktop.
// Uses Lenis (assets/ie-lenis.min.js, MIT). Phones and tablets keep their native scrolling,
// and it stays off for "reduce motion", in the theme editor, and while a drawer or pop-up locks the page.
// Turn it off in Theme settings > InnerEaze effects.
(() => {
  if (window.Shopify && window.Shopify.designMode) return;
  const desk = matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
  const still = matchMedia('(prefers-reduced-motion: reduce)');
  let lenis = null;
  let wrapper = null;
  let raf = 0;
  let lockObserver = null;

  // Let inner scroll areas (drawers, dropdown lists, chat boxes) scroll on their own
  const ownScroller = (el) => {
    if (el.tagName === 'DIALOG') return true;
    if (el.scrollHeight <= el.clientHeight + 1) return false;
    const oy = getComputedStyle(el).overflowY;
    return oy === 'auto' || oy === 'scroll';
  };

  // Only animate while something is moving: no endless frame loop when the page is idle.
  // Lenis times each frame from the previous one, so restart its clock at the start of every run,
  // otherwise the first frame after a pause sees a huge gap and finishes the glide instantly.
  let fresh = true;
  const tick = (time) => {
    if (!lenis) { raf = 0; return; }
    if (fresh) { lenis.time = time - 16.7; fresh = false; }
    lenis.raf(time);
    if (lenis.isScrolling) {
      raf = requestAnimationFrame(tick);
    } else {
      raf = 0;
      fresh = true;
    }
  };
  const kick = () => { if (lenis && !raf) raf = requestAnimationFrame(tick); };

  const syncLock = () => {
    if (!lenis) return;
    if (document.documentElement.hasAttribute('scroll-lock')) lenis.stop();
    else lenis.start();
    kick();
  };

  function init() {
    if (lenis || typeof window.Lenis !== 'function') return;
    wrapper = document.querySelector('.page-wrapper');
    if (!wrapper) return;
    // Atelier makes .page-wrapper the scroller from 990px up; only take over if it really scrolls
    const oy = getComputedStyle(wrapper).overflowY;
    if (oy !== 'auto' && oy !== 'scroll') return;
    lenis = new window.Lenis({
      wrapper,
      content: wrapper,
      eventsTarget: wrapper,
      smoothWheel: true,
      lerp: 0.1,
      prevent: ownScroller,
      __experimental__naiveDimensions: true, // measure the live page height (lazy images, accordions)
    });
    const scrollTo = lenis.scrollTo.bind(lenis);
    lenis.scrollTo = (...args) => { scrollTo(...args); kick(); };
    window.ieLenis = lenis;
    wrapper.addEventListener('wheel', kick, { passive: true, capture: true });
    lockObserver = new MutationObserver(syncLock);
    lockObserver.observe(document.documentElement, { attributes: true, attributeFilter: ['scroll-lock'] });
    syncLock();
  }

  function destroy() {
    if (!lenis) return;
    cancelAnimationFrame(raf);
    raf = 0;
    wrapper.removeEventListener('wheel', kick, { capture: true });
    lockObserver.disconnect();
    lenis.destroy();
    lenis = null;
    window.ieLenis = null;
  }

  const update = () => (desk.matches && !still.matches ? init() : destroy());
  desk.addEventListener('change', update);
  still.addEventListener('change', update);
  update();
})();
